export default __webpack_public_path__ + "static/media/market.037b1db5.png";